'use strict'

const uniqBy_ = require('lodash/uniqBy')

module.exports = components => uniqBy_(components, 'id')



// WEBPACK FOOTER //
// ./helpers/getUniqueComponents.js